<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->

      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-lr-30 m-b-30 m-t-20 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   [invalidateSubject]="invalidateSubject"
                                   sortFieldKey="Title"
                                   [pageSize]="300"
                                   (valueChanged)="onGridCellValueChange($event)">
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

